<template>
  <div>
    <div v-for="item in dataList" :key="item.id" class="wrap-style">
      <div v-if="isZh" class="triangle" />
      <div class="page-style">
        <div class="content">
          <div class="content-left">
            <div class="line2">
              <div class="line2-left">物料编码：</div>
              <div class="line2-right">{{ item.itemCode }}</div>
            </div>
            <div class="line2">
              <div class="line2-left">批<span class="mlr55">次</span>号：</div>
              <div class="line2-right">{{ item.lotNumber }}</div>
            </div>
            <div class="line2">
              <div class="line2-left">物料名称：</div>
              <div class="line2-right">{{ item.itemName }}</div>
            </div>
            <div class="line2">
              <div class="line2-left">包件序号：</div>
              <div class="line2-right">{{ item.packageNumber }}</div>
            </div>
          </div>
          <div class="content-right">
            <div class="qrCode-border">
              <QrCode id="qrCode" :text="qrCodeText(item)" width="80" height="80" ref="qrCode" />
              <!-- <div class="qrCode-num">{{ item.serialNumber }}</div> -->
            </div>
          </div>
        </div>
        <div class="line1">
          <div class="line1-left">规格描述：</div>
          <div class="line1-right">{{ item.description }}</div>
        </div>
        <div class="line1">
          <div class="line1-left">包装明细：</div>
          <div class="line1-right">{{ item.packageList }}</div>
        </div>
        <div class="line1">
          <div class="line1-left">仓<span class="ml22">库</span>：</div>
          <div class="line1-right">{{ item.destination }}</div>
        </div>
      </div>
      <BarCode :text="item.serialNumber" width="3" height="40" fontSize="14" />
    </div>
  </div>
</template>

<script>
import QrCode from '@/components/QrCode/index'
import BarCode from '@/components/BarCode/index'

export default {
  components: {
    QrCode,
    BarCode
  },
  props: {
    // 判断大货类型是否为专货5
    isZh: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      printTime: '',
      dataList: []
    }
  },
  created () {},
  methods: {
    show (val) {
      this.dataList = val
      this.printTime = this.$moment(new Date()).format('YYYY/MM/DD HH:mm:ss')
    },
    // 二维码内容
    qrCodeText (item) {
      // const arr = []
      // arr.push(item.serialNumber) // 标签码
      // arr.push(item.assemblyItemId) // 物料编码
      // arr.push(item.lotNumber) // 批次号
      // arr.push(item.itemName) // 物料名称
      // arr.push(item.packageNumber) // 包件序号
      // arr.push(item.description) // 规格描述
      // arr.push(item.packageList) // 包装明细
      // arr.push(item.destination) // 仓库
      // return arr.join("||")
      return item.serialNumber
    }
  }
}
</script>

<style scoped lang="less">
.wrap-style{
  position: relative;
  page-break-after: always;
  padding: 10px 2px;
}
.page-style{
  width: 100%;
  font-family: Arial !important;
}
.triangle {
  position: absolute;
  bottom: 10px;
  right: 0;
  width: 0;
  height: 0;
  border-left: 50px solid transparent; /* 左边透明，形成斜边 */
  border-bottom: 50px solid black; /* 下边为黑色，形成直角三角形 */
}
.content{
  font-weight: 600;
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .content-left{
    width: 65%;
    .line2{
      display: flex;
      // align-items: center;
      width: 100%;
      // min-height: 50px;
      .line2-left{
        width: 35%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 11px;
        // min-height: 50px;
        height: 20px;
      }
      .line2-right{
        width: 65%;
        // min-height: 50px;
        font-size: 10px;
        display: flex;
        // justify-content: flex-start;
        align-items: center;
        padding: 0 5px;
      }
    }
  }
  .content-right{
    width: 35%;
    display: flex;
    // align-items: center;
    justify-content: flex-start;
    height: 80px;
    .qrCode-border{
      border: 1px solid #efefef;
      width: 90px;
      height: 90px;
      padding: 3px;
      position: relative;
      .qrCode-num{
        position: absolute;
        width: 70px;
        bottom: -20px;
        text-align: center;
        font-size: 10px;
      }
    }
  }
}
.line1{
  font-weight: 600;
  display: flex;
  // align-items: center;
  width: 100%;
  // height: 50px;
  .line1-left{
    width: 22.8%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 11px;
    height: 20px;
  }
  .line1-right{
    width: 70%;
    // height: 20px;
    font-size: 10px;
    display: flex;
    // justify-content: flex-start;
    align-items: center;
    padding: 0 5px;
  }
}
.ml22 {
  margin-left: 22px;
}
.mlr55 {
  margin-left: 5.5px;
  margin-right: 5.5px;
}
</style>
